import _ from 'lodash';
import React from 'react';

import { useStoreDetailActivity_OrderListPaneLazyQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface IOrder {
  id: string;
  orderNumber: string;
  orderDate: DateTime;
  customerFullName: string;
  customerEmail: string;
}

export interface IData {
  orders: IOrder[];
}

export function useQuery(storeId: string) {
  const [fnQuery, tuple] = useStoreDetailActivity_OrderListPaneLazyQuery();



  const fnWrappedQuery = React.useCallback(
    (omniFreeText: string) => {
      fnQuery({
        variables: {
          storeId,
          omniFreeText
        }
      });
    },
    [fnQuery, storeId]
  );



  const wrappedTuple = React.useMemo(
    () => {
      const data: IData = {
        orders: _.map(tuple.data?.orders.nodes ?? [], (order): IOrder => ({
          id: order.id,
          orderNumber: order.orderNumber,
          orderDate: DateTime.fromISO(order.orderDate),
          customerEmail: order.customer.email,
          customerFullName: `${order.customer.firstName} ${order.customer.lastName}`
        }))
      };

      return [
        fnWrappedQuery, {
          ...tuple,
          data
        }
      ] as const;
    },
    [fnWrappedQuery, tuple]
  );



  return wrappedTuple;
}
